import callAPI from 'api'

export const getUserGuide = async () =>
  await callAPI<{ link: string }>('crm_get_user_guide', undefined, { requireAuthorization: true })
